module.exports = __webpack_public_path__ + "img/p3-2-3.973d4ac1.png";